import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { FileUploader } from "react-drag-drop-files";
import { useSelector } from "react-redux";
import axios from "axios";
import { AddIcon, CloseIcon, DeleteIcon, RightArrowIcon } from "../../Static/icons/iconshere";
import { BtnLoading } from "../../animations/BtnLoading";
import apiClient from "../../apiClient";
import { FETCH_AR_MODULE_DETAIL, UPDATE_AR_MODULE_DETAIL } from "../../apiClient/apiEndpoints";
import DrawLine from "./DrawLine";
import MediaGalleryModal from "../Details/MediaGalleryModal";
import { generateShortUUID, imageFileTypes, pointerMediaFileTypes, pointerTypeOptions } from "../../utils/constants";
import { AR_CONTENT_HOTSPOT_FILE } from "../../constant/limitSize";
import { VALUE } from "../../constant/constant";
import { getAllowedMaxFileSize, isFileSizeOverMaxSize } from "../../utils/common";


const isCurrentActive = (id, hotspotList) => {
  let pointData = null;
  hotspotList?.forEach((item) => {
    item.points?.map((point) => {
      if (point.id === id) {
        pointData = item;
      }
    });
  });

  return pointData?.isOpen;
};
const isPointTooltip = (id, hotspotList) => {
  let pointData = null;
  hotspotList?.forEach((item) => {
    item.points?.map((point) => {
      if (point.id === id) {
        pointData = item;
      }
    });
  });

  return pointData?.type?.value === "TOOLTIP";
};

const TargetArea = ({ uuid }) => {
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const UNO_URL = configData?.config?.UNO_URL;
  const [showTargetModal, setShowTargetModal] = useState(false);
  const [targetImage, setTargetImage] = useState("");
  const [hotspotList, setHotspotList] = useState([]);
  const [fileUploadError, setFileUploadError] = useState(null);
  const [activeHotspotId, setActiveHotspotId] = useState("");
  const [arContentMode, setArContentMode] = useState("model");
  const [isAddHotstopDisabled, setIsAddHotstopDisabled] = useState(false);
  const divCoordinates = useRef(null);
  const targetImageReplaceRef = useRef(null);
  const [loading, setLoading] = useState({
    imageUpload: false,
    saveHotspot: false,
  });
  const [show, setShow] = useState({
    hotspotSelection: false,
    mediaModal: false,
  });
  const [error, setError] = useState(false);

  let visiblePointers = hotspotList?.flatMap((item) => item?.points) || [];

  const fetchBasicModuleDetails = async () => {
    try {
      const detail = await apiClient.get(`${UNO_URL}${FETCH_AR_MODULE_DETAIL}/${uuid}`);
      setTargetImage(detail?.versions?.[0]?.data?.target?.targetLink || "");
      setArContentMode(detail?.versions?.[0]?.data?.contentMode || "hotspot");
      
      const savedHotspots = detail?.versions?.[0]?.data?.target?.targetHotspots?.map((pointer) => {
          return {
            id: generateShortUUID(),
            points: pointer?.points?.map((point) => ({ id: generateShortUUID(), x: point.x, y: point.y })),
            name: pointer?.data?.title || "",
            description: pointer?.data?.description || "",
            type: pointerTypeOptions?.find((type) => type.value === pointer?.type),
            files: pointer?.data?.files || [],
            isOpen: false,
          };
        }) || [];
      setHotspotList(savedHotspots);
    } catch (error) {
      console.log(error);
    }
  };

  const handleTargetImageUpload = async (file) => {
    try {
      if (!file || !file.type.startsWith("image/")) {
        return;
      }
      const formData = new FormData();
      formData.append("file", file);

      const res = await axios.post(`${UNO_URL}/api/resource/ar/upload/image/${uuid}`, formData, {
        headers: {
          "Content-Type ": "multipart/form-data",
          Authorization: `Bearer ${userData?.token}`,
        },
      });
      setTargetImage(res?.data?.url);
    } catch (error) {
      console.log(error);
    }
  };

  const handlePointerMediaUpload = async (files) => {
    try {
      
      if (!files) return;
      const file = files;

      if(isFileSizeOverMaxSize(file.size, AR_CONTENT_HOTSPOT_FILE )){
        setFileUploadError(`File size is more then ${getAllowedMaxFileSize(AR_CONTENT_HOTSPOT_FILE)}`) 
        return;
      }

      const extension = file.name.split(".").pop().toLowerCase();
      if (!pointerMediaFileTypes.includes(extension)) {
        alert(`Invalid file type. Allowed types: ${pointerMediaFileTypes}`);
        return;
      }
      let fileType = "image";
      if (file.type.startsWith("video/")) {
        fileType = "video";
      } else if (file.type === "application/pdf") {
        fileType = "pdf";
      }

      const formData = new FormData();
      formData.append("file", file);
      const res = await axios.post(`${UNO_URL}/api/resource/ar/upload/${fileType}/${uuid}`, formData, {
        headers: {
          "Content-Type ": "multipart/form-data",
          Authorization: `Bearer ${userData?.token}`,
        },
      });
      setHotspotList((prev) => {
        return prev.map((pointer) => {
          if (pointer.isOpen) {
            return { ...pointer, files: [...(pointer.files || []), res?.data?.url] };
          } else {
            return pointer;
          }
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleExpandHotspot = (id, isOpen) => {
    setHotspotList((prev) => {
      return prev.map((item) => {
        if (item.id === id) {
          return { ...item, isOpen };
        } else {
          return { ...item, isOpen: false };
        }
      });
    });
  };

  const handlePointerDataChange = (pointerId, pointerField, value) => {
    if (pointerField === "type" && value?.value === "TOOLTIP") {
      setShow((prev) => ({ ...prev, hotspotSelection: true }));
      setActiveHotspotId(pointerId);
    } else if (pointerField === "type" && value?.value === "POINTER") {
      setShow((prev) => ({ ...prev, hotspotSelection: false }));
      setIsAddHotstopDisabled(false);
      setActiveHotspotId("");
    }
    setHotspotList((prev) => {
      return prev.map((pointer) => {
        if (pointer.id === pointerId) {
          if (pointerField === "type" && value?.value === "TOOLTIP" && pointer?.points?.length < 2) {
            setIsAddHotstopDisabled(true);
          }
          if (pointerField === "type" && value?.value === "POINTER" && pointer?.points?.length > 1) {
            return { ...pointer, [pointerField]: value, points: [pointer.points[0]] };
          } else {
            return { ...pointer, [pointerField]: value };
          }
        } else {
          return pointer;
        }
      });
    });
  };

  const closeModal = () => {
    setShowTargetModal(false);
    setError(false);
    setShow({ hotspotSelection: false, mediaModal: false });
    setIsAddHotstopDisabled(false);
    setActiveHotspotId("");
    setLoading({ imageUpload: false, saveHotspot: false });
    setHotspotList([])
  };

  const handleSaveBasicDetails = async () => {
    try {
      setLoading((prev) => ({ ...prev, saveHotspot: true }));
      const payload = {
        version: {
          target: {
            targetLink: targetImage,
            targetHotspots: hotspotList?.map((pointer) => {
              return {
                type: pointer?.type?.value,
                points: pointer?.points?.map((i) => ({ x: i.x, y: i.y }))
              };
            }),
            contentMode: arContentMode,
          },

          targetPointersData: hotspotList?.map((pointer) => ({
            title: pointer?.name || "",
            description: pointer?.description || "",
            files: pointer?.files || [],
          })),
        },
      };
      await apiClient.post(`${UNO_URL}${UPDATE_AR_MODULE_DETAIL}/${uuid}`, payload);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading((prev) => ({ ...prev, saveHotspot: false }));
      closeModal();
      fetchBasicModuleDetails();
    }
  };

  const handleNewHotspotClick = () => {
    setShow((prev) => ({ ...prev, hotspotSelection: true }));
  };

  const handleTargetImageClick = (e) => {
    if (show.hotspotSelection) {
      const rect = e.target.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      if (activeHotspotId) {
        const isPointerInList = hotspotList.find((hotspot) => hotspot.id === activeHotspotId);
        if (!isPointerInList) {
          setHotspotList((prev) => [
            ...prev,
            {
              id: generateShortUUID(),
              points: [{ id: generateShortUUID(), x, y }],
              type: null,
              isOpen: true,
            },
          ]);
        } else {
          if (isPointerInList?.points?.length === 1 && isPointerInList?.type?.value === "TOOLTIP") {
            setHotspotList((prev) => {
              return prev.map((pointer) => {
                if (pointer.id === isPointerInList.id) {
                  return { ...pointer, points: [...(pointer?.points || []), { id: generateShortUUID(), x, y }] };
                } else {
                  return pointer;
                }
              });
            });
            setIsAddHotstopDisabled(false);
          } else {
            setHotspotList((prev) => {
              return prev.map((pointer) => {
                if (pointer.id === isPointerInList.id) {
                  return { ...pointer, points: [{ id: generateShortUUID(), x, y }] };
                } else {
                  return pointer;
                }
              });
            });
          }
        }
      } else {
        setHotspotList((prev) => [
          ...(prev || []).map((item) => ({ ...item, isOpen: false })),
          {
            id: generateShortUUID(),
            points: [{ id: generateShortUUID(), x, y }],
            type: { label: "Pointer", value: "POINTER" },
            isOpen: true,
            name: `Hotspot ${(prev.length || 0) + 1}`,
          },
        ]);
      }
      setActiveHotspotId("");
      setShow((prev) => ({ ...prev, hotspotSelection: false }));
    }
  };

  const onPointerClick = (e, pointId) => {
    e.stopPropagation();
    if (show.hotspotSelection) {
      return;
    }
    setHotspotList((prev) => {
      return prev.map((pointer) => {
        const findPointer = pointer.points?.find((item) => item.id === pointId);
        if (findPointer) {
          return { ...pointer, isOpen: true };
        } else {
          return { ...pointer, isOpen: false };
        }
      });
    });
  };

  const handleShowHotspotMediaModal = () => {
    setShow((prev) => ({ ...prev, mediaModal: true }));
  };

  const closeMediaModal = () => {
    setShow((prev) => ({ ...prev, mediaModal: false }));
  };

  const deletePointerMediaHandler = (_, url) => {
    setHotspotList((prev) => {
      return prev.map((pointer) => {
        if (pointer.isOpen) {
          return { ...pointer, files: pointer.files?.filter((fileUrl) => fileUrl !== url) };
        } else {
          return pointer;
        }
      });
    });
  };

  const handleDeleteHotspot = (pointerId) => {
    if (pointerId === activeHotspotId) {
      setIsAddHotstopDisabled(false);
      setShow({ hotspotSelection: false, mediaModal: false });
      setActiveHotspotId("");
    }
    setHotspotList((prev) => prev.filter((pointer) => pointer.id !== pointerId));
  };

  const handleReplaceTargetImageClick = () => {
    targetImageReplaceRef.current.click();
  };

  const openUpdateHotspotModal = () => {
    setShowTargetModal(true);
  };

  useEffect(() => {
    if (uuid && showTargetModal) {
      fetchBasicModuleDetails();
    }
  }, [uuid, showTargetModal]);

  useEffect(() => {
    if (activeHotspotId) {
      const selectedHotspot = hotspotList?.find((pointer) => pointer.id === activeHotspotId);
      if (selectedHotspot?.type?.value === "TOOLTIP" && selectedHotspot?.points?.length < 2) {
        setIsAddHotstopDisabled(true);
      }
    }
  }, [activeHotspotId]);

  return (
    <>
      <div className="detail-component fortarget closed mt-3">
        {!showTargetModal ? (
          <h6>
            Update Hotspot
            <span className="OpenCloseBtn" onClick={openUpdateHotspotModal}>
              View
            </span>
          </h6>
        ) : (
          <div className="targetParent">
            {!targetImage ? (
              <>
                <FileUploader
                  label={"drag & drop or choose file to use and Add Target View"}
                  name="file"
                  types={imageFileTypes}
                  handleChange={handleTargetImageUpload}
                />
                <button className="goBack" onClick={closeModal}>
                  <CloseIcon />
                </button>
              </>
            ) : (
              <div className="targetContentArea">
                <div className="imageSide">
                  {!loading.imageUpload ? (
                    <div className="imageSideWrapper">
                      <div className="imgWrapper" onClick={handleTargetImageClick} ref={divCoordinates}>
                        <img src={targetImage} referrerPolicy="no-referrer" />

                        {arContentMode === "hotspot" && (
                          <>
                            {visiblePointers?.map((item) => {
                              const isTooltip = isPointTooltip(item.id, hotspotList);
                              const isActive = isCurrentActive(item.id, hotspotList);
                              return (
                                <span
                                  key={item.id}
                                  className={`pointer-dot ${isTooltip ? "pointer-tooltip" : ""} ${isActive ? "activeDot" : ""
                                    }`}
                                  style={{ top: `${item.y}%`, left: `${item.x}%` }}
                                  onClick={(e) => onPointerClick(e, item.id)}
                                />
                              )
                            })}

                            {hotspotList?.filter((p) => p?.type?.value === "TOOLTIP").map((pointer) => (
                              <DrawLine
                                key={pointer.id}
                                points={pointer.points}
                                containerRef={divCoordinates}
                              />
                            ))}

                            {arContentMode === "hotspot" && show.hotspotSelection && (
                              <span class="selection-window">Click anywhere on the image to create a Hotspot</span>
                            )}

                          </>
                        )}

                      </div>
                    </div>
                  ) : (
                    <div className="loading">
                      <BtnLoading />
                    </div>
                  )}
                </div>

                <div className={`infoSide ${hotspotList?.length > 0 ? "" : "empty-list"}`}>
                  {hotspotList?.length === 0 ? (
                    <>
                      <div className="addHotspotBox-wrapper">
                        {arContentMode === "hotspot" && (
                          <div className="addHotspotBox" onClick={handleNewHotspotClick}>
                            <AddIcon />
                            <p>Click to start hotspot creation mode</p>
                          </div>
                        )}
                      </div>
                    </>
                  ) : (
                    <div className="hotspotList">
                      {arContentMode === "hotspot" &&
                        <>
                          <div className="hotspotlistcont">
                            <h6>Hotspots List</h6>
                          </div>
                          <div className="listWrapper">
                            {/* Existing hotspots */}
                            {hotspotList.map((pointer) => {
                              return (
                                <div key={pointer?.id} className={`listItem-wrapper${pointer?.isOpen ? " active" : ""}`}>
                                  <div className="listItem">
                                    <span
                                      className="closeOpen"
                                      onClick={() => handleExpandHotspot(pointer.id, !pointer.isOpen)}
                                    >
                                      <RightArrowIcon />
                                    </span>
                                    <p>{pointer?.name}</p>
                                    <span className="actionbtn" onClick={() => handleDeleteHotspot(pointer.id)}>
                                      <DeleteIcon />
                                    </span>
                                  </div>

                                  {/* Only show details when row is open */}
                                  <div className={`listItemData${pointer?.isOpen ? " active" : ""}`}>
                                    <div className="form-group">
                                      <label>
                                        Select Interaction Method <span>*</span>
                                      </label>
                                      <Select
                                        name="interaction-type"
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        placeholder="Select Target Scan"
                                        options={pointerTypeOptions}
                                        value={pointer?.type}
                                        onChange={(value) => handlePointerDataChange(pointer.id, "type", value)}
                                      />
                                    </div>

                                    <div className="form-group">
                                      <label>
                                        Hotspot Name <span>*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter name"
                                        name="name"
                                        value={pointer?.name}
                                        onChange={(e) => handlePointerDataChange(pointer.id, "name", e.target.value)}
                                      />
                                    </div>

                                    <div className="form-group">
                                      <label>Description</label>
                                      <textarea
                                        name="project_about"
                                        className="form-control"
                                        rows={3}
                                        value={pointer?.description}
                                        onChange={(e) =>
                                          handlePointerDataChange(pointer.id, "description", e.target.value)
                                        }
                                      />
                                    </div>

                                    <div className="form-group media">
                                      <label>Media Files</label>
                                      <div className="media-wrapper">
                                        <p>{pointer?.files?.length} Media Files</p>
                                        <span className="addFile" onClick={handleShowHotspotMediaModal}>
                                          View/Upload Files
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </>
                      }
                    </div>
                  )}

                  {error && <p className="text-danger">Please upload 3D models</p>}
                  <div class={`footerbtn`}>
                    {targetImage && (
                      <>
                        <input
                          type="file"
                          accept="image/*"
                          style={{ display: "none" }}
                          ref={targetImageReplaceRef}
                          onChange={(e) => handleTargetImageUpload(e.target.files[0])}
                        />
                        <button onClick={handleReplaceTargetImageClick}>Replace Image</button>{" "}
                        {arContentMode === "hotspot" && hotspotList?.length > 0 && (
                          <button
                            onClick={handleNewHotspotClick}
                            disabled={isAddHotstopDisabled}
                            className={isAddHotstopDisabled ? "disabled" : ""}
                          >
                            Add New Hotspot
                          </button>
                        )}
                        <button onClick={handleSaveBasicDetails} disabled={isAddHotstopDisabled || loading.saveHotspot}>
                          {loading.saveHotspot ? <BtnLoading /> : "Save"}
                        </button>
                      </>
                    )}
                    <button onClick={closeModal}>Exit</button>
                  </div>
                </div>
              </div>
            )}{" "}
          </div>
        )}
      </div>

      <MediaGalleryModal
        mediaGalleryShow={show.mediaModal}
        GalleryClose={closeMediaModal}
        fileTypes={pointerMediaFileTypes}
        handleProductImageChange={handlePointerMediaUpload}
        allSavedFileUrl={hotspotList?.find((pointer) => pointer?.isOpen)?.files?.map((url) => ({ url })) || []}
        deleteProductImage={deletePointerMediaHandler}
        uploadedProductFiles={[]}
        saveProductImagesFile={closeMediaModal}
        multipleUpload={false}
        maxFileSize={AR_CONTENT_HOTSPOT_FILE[VALUE]}
        showCloseButton={false}
        fileUploadError={fileUploadError}
      />
    </>
  );
};

export default TargetArea;
